module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 27
// module chunks = 0